import { Injectable } from "@angular/core";
import packageJson from "../../../../../package.json";

@Injectable({
    providedIn: "root",
})
export class AppVersionService {
    constructor() {}


    getVersionApp(): string {
        return packageJson.version;
    }
}
